import React, { useEffect, useState } from "react";
import Chart from 'react-apexcharts';
import '../../cssfiles/homepage.css';
import { colors } from "@mui/material";

const piechartoptions = {
    chart: {
        id: 1,
        width: 380,
        type: 'pie',
    },
    labels: [],
    colors: [],
    responsive: [{
        breakpoint: 480,
        options: {
            chart: {
                width: 200
            },
            legend: {
                position: 'bottom'
            }
        }
    }]
}



export default function Piechartcard (props) {
    
    const [tagporpslist, setTagpropslist] = useState([])
    const [editorseries, setEditorseries] = useState([])
    const [chartoptions, setChartoption] = useState(piechartoptions)

    useEffect(() => {
        if(props.extendedprops !== undefined) {
            if(props.extendedprops.hasOwnProperty("tagpropslist")) {
                setTagpropslist(props.extendedprops.tagpropslist)
                var data = []
                var labels = []
                var colors = []
                for(let i=0; i<props.extendedprops.tagpropslist.length; i++) {
                    labels.push(props.extendedprops.tagpropslist[i].discription)
                    colors.push(props.extendedprops.tagpropslist[i].textcolor)
                    data.push(100/props.extendedprops.tagpropslist.length)
                }
                               
                var options = {...chartoptions}
                options.chart.id = options.chart.id + 1
                options.labels = labels
                options.colors = colors
                setEditorseries(data)
                setChartoption(options)
                console.log("data ", data, labels)
            }
        }
        //console.log("tagporpslist ",props.extendedprops.tagpropslist)
    },[props.extendedprops])


    return(
        <div style={{height: 'calc(100% - 55px)', width: 'calc(100% - 15px)', padding: '10px', overflow: 'auto'}}>
            <Chart options={chartoptions} series={editorseries} type='pie' height="85%" width="100%" />
        </div>
        
    )
}